import { render, staticRenderFns } from "./NewCourseEconomyStep.vue?vue&type=template&id=9e5b1ae0&"
import script from "./NewCourseEconomyStep.vue?vue&type=script&lang=ts&"
export * from "./NewCourseEconomyStep.vue?vue&type=script&lang=ts&"
import style0 from "./NewCourseEconomyStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VContainer,VForm,VSelect,VSwitch})
